// extracted by mini-css-extract-plugin
var _1 = "SeeDetailsModal_legal__45rZf";
var _2 = "768px";
var _3 = "SeeDetailsModal_modalContainer__HfMKc";
var _4 = "SeeDetailsModal_modalOverlay__oySM5";
var _5 = "SeeDetailsModal_modalWrapper__RP9si";
var _6 = "'../../shared.module.css'";
export { _1 as "legal", _2 as "md", _3 as "modalContainer", _4 as "modalOverlay", _5 as "modalWrapper", _6 as "shared" }
